import { SVGProps } from 'react';

const LineSvg = ({ children, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    {...props}
  >
    {children}
  </svg>
);

export const RowAuditIcon = (props: SVGProps<SVGSVGElement>) => (
  <LineSvg {...props}>
    <path d="M3 6h11M3 12h6M3 18h6" />
    <circle cx="15.5" cy="14.5" r="3.5" />
    <path d="m18.2 17.2 2.8 2.8" />
  </LineSvg>
);

export const RowDeleteIcon = (props: SVGProps<SVGSVGElement>) => (
  <LineSvg {...props}>
    <path d="M5 7h14M10 7V5h4v2M7 7l1 12h8l1-12" />
  </LineSvg>
);

export const RowEditIcon = (props: SVGProps<SVGSVGElement>) => (
  <LineSvg {...props}>
    <path d="M4 20h4L19 9l-4-4L4 16z" />
    <path d="m13.5 6.5 4 4" />
  </LineSvg>
);

export const RowCopyIcon = (props: SVGProps<SVGSVGElement>) => (
  <LineSvg {...props}>
    <rect x="8" y="8" width="11" height="11" rx="2" />
    <path d="M5 15V6a1 1 0 0 1 1-1h9" />
  </LineSvg>
);
